export default "__VITE_ASSET__Bzi1ZiG6__"